module.exports = __webpack_public_path__ + "img/badge-fastest-conversion-keyvue-blue.90593e37.png";